import { useAuthStore } from "@/stores/auth";
import { getEnvConfig } from "@/configs/UrlConfig";
import { RecoveryPassword, RecoverySession, User, UserSession } from "./types";
import { Response } from "../types";
import { getResponse } from "../utils";
import { mdiEarthOff } from "@mdi/js";

export class AuthService {
    async login(email: string, password: string): Promise<Response<UserSession>>{
        const url = `${getEnvConfig().apiURL}/auth/login?type=2`

        const formData = new FormData() 
        formData.append('username', email)
        formData.append('password', password)

        return getResponse(url, undefined, 'POST', undefined, formData)
    }

    async getProfile(token: string): Promise<Response<User>> {
        const url = `${getEnvConfig().apiURL}/auth/me`

        return getResponse(url, token)
    }

    async logout(token: string): Promise<Response<any>>{
        const url = `${getEnvConfig().apiURL}/auth/logout`

        return getResponse(url, token, 'POST')
    }

    async register(userInfo: object): Promise<Response<User>>{
        const url = `${getEnvConfig().apiURL}/auth/register`
        return getResponse(url, undefined, 'POST', userInfo)
    }

    async forgotPassword(email:string):Promise<Response<UserSession>>{
        const url = `${getEnvConfig().apiURL}/auth/forgot-password?type=2`
        return getResponse(url,undefined,'POST',{email:email});
    }
    async recoveryPassword(recoveryPassword:RecoveryPassword):Promise<Response<RecoverySession>>{
        const url = `${getEnvConfig().apiURL}/auth/reset-password`
        return getResponse(url,undefined,'POST',{token:recoveryPassword.token,"new_password":recoveryPassword.new_password,"confirm_password":recoveryPassword.confirm_password, type:"2"});
    }
    /**
     * Valida que la sesion del usuario es valida.
     * @returns Retorna True si la sesión es valida y False en caso contrario
     */
    async hasValidUserSession(){
        const authStore = useAuthStore()        
        if(authStore.token){
            const response = await this.getProfile(authStore.token)
            if(response.success){
                authStore.setUser(response.data)
                return true
            }
            else{
                authStore.logout()
                return false
            }
        }
        return false
    }
}